<template>
  <div>
    <div class="card">
      <div class="card-content">
        <div class="card-body donut-chart-wrapper">
          <div id="donut-chart" class="d-flex justify-content-center"></div>
          <ul class="list-inline d-flex justify-content-around mb-0">
            <li>
              <span class="bullet bullet-xs bullet-info mr-50"></span>{{$t('Male')}}
            </li>
            <li>
              <span class="bullet bullet-xs bullet-warning mr-50"></span>{{$t('Female')}}
            </li>
            <li>
              <span class="bullet bullet-xs bullet-primary mr-50"></span>{{$t('Private')}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts'
export default {
  props: ["genders"],
  methods: {
    initGenderChart(maleGender, femaleGender, privateGender) {
      const donutChartOption = {
        chart: {
          width: 200,
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        series: [maleGender, femaleGender, privateGender],
        labels: ["Male", "Female", "Private"],
        stroke: {
          width: 0,
          lineCap: "round",
        },
        colors: ["#00CFDD", "#FDAC41", "#5A8DEE"],
        plotOptions: {
          pie: {
            donut: {
              size: "90%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "15px",
                  colors: "#596778",
                  offsetY: 20,
                  fontFamily: "IBM Plex Sans",
                },
                value: {
                  show: true,
                  fontSize: "26px",
                  fontFamily: "Rubik",
                  color: "#475f7b",
                  offsetY: -20,
                  formatter: function (val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#828D99",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce(function (a, b) {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        legend: {
          show: false,
        },
      };
      const donutChart = new ApexCharts(
        document.querySelector("#donut-chart"),
        donutChartOption
      );

      donutChart.render();
    },
  },
  mounted() {
    const male = this.genders.male ? this.genders.male : 0;
    const female = this.genders.female ? this.genders.female : 0;
    const priv = this.genders.private ? this.genders.private : 0;

    this.initGenderChart(male, female, priv);
  },
};
</script>